var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.servers),function(ser){return (!_vm.serverObj[ser].readonly && !_vm.serverObj[ser].test )?_c('b-col',{key:ser,attrs:{"sm":"6","lg":"6"}},[_c('poketime-card',{attrs:{"server":ser}})],1):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }